import { useEffect } from 'preact/hooks'
import useForceUpdate from 'lib/useForceUpdate'

// `enabled` lets a caller that renders a fixed value -- an absolute date, say
// -- keep calling the hook unconditionally without joining the ticker.
export default function useUpdateEverySecond(enabled = true){
  const forceUpdate = useForceUpdate()
  useEffect(
    () => {
      if (!enabled) return
      everySecond.add(forceUpdate)
      return () => {
        everySecond.remove(forceUpdate)
      }
    },
    [enabled]
  )
}

const everySecond = {
  subscribers: new Set(),
  start(){
    if (this.timeout) return
    this.timeout = setInterval(() => { this.call() }, 1000)
  },
  stop(){
    clearInterval(this.timeout)
    delete this.timeout
  },
  add(subscriber) {
    this.subscribers.add(subscriber)
    this.start()
  },
  remove(subscriber){
    this.subscribers.delete(subscriber)
    if (this.subscribers.size === 0) this.stop()
  },
  call(){
    this.subscribers.forEach(subscriber => { subscriber() })
  },
}
